import { useMasteryMapApi } from '@api/mastery-map/mastery-map.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

import { isNotFoundError, show404, showRequestError } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const assessmentId = Number(to?.params?.assessment)

  if (!assessmentId) {
    return show404()
  }

  const { fetchMasteryMap } = useMasteryMapApi()

  onDisciplineReady(() => {
    void fetchMasteryMap(assessmentId, {
      onError: err => (isNotFoundError(err) ? show404() : showRequestError()),
    })
  }, { hook: 'NONE' })
})
